import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSparkleOutline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n            .a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:3;}\n        " }) }),
		/* @__PURE__ */ _jsx("title", { children: "sparkle-outline" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M12,1 Q13,11 23,12 Q13,13 12,23 Q11,13 1,12 Q11,11 12,1 Z"
		})
	]
});
export default SvgSparkleOutline;
